import React, { FunctionComponent, useEffect } from 'react'
import { Close } from '@mui/icons-material'
import { Divider } from '@mui/material'
import { OfferType, SpecialOffer, SpecialOfferContent } from '@/services/cms-api/home-page-content/types'
import { useLanguage } from '@/context/LanguageContext'
import { useRouter } from 'next/router'
import NewsContentRenderer from '@/components/ui/NewsContentRenderer'
import SocialShare from '@/components/ui/SocialShare'
import Image from 'next/image'
import { IMG_URL } from '@/utils/constants'
import { getSystemEnv } from '@/utils/env'
import DarkIconButton from '@/components/ui/Buttons/SecondaryIconButton'

interface Prop {
  onClose: () => void
  data: SpecialOffer

}

const NewsContent: FunctionComponent<Prop> = ({ data, onClose }) => {
  const { locale } = useLanguage()
  const router = useRouter()

  useEffect(() => {
    router.beforePopState(({ as }) => {
      if (as !== router.asPath) {
        onClose()
      }
      return false
    })
    return () => {
      router.beforePopState(() => true)
    }
  }, [router])

  if (data === undefined || data === null) {
    return <></>
  }

  return (
    <div className='bg-surfaceLow p-4'>
      <div className='flex justify-end'>
        <DarkIconButton type='soft' size='sm' icon={<Close />} onClick={onClose} />
      </div>
      <div className='flex flex-col items-center'>
        <Image draggable={false} alt='img' width={1000} height={1000} src={IMG_URL + data.headerImage} className='rounded-xl 2xl:w-[997px] xl:w-[900px] lg:w-[803px] md:w-[706px] w-[95vw] aspect-[2/1]' />
        <span className='text-textHigh font-extrabold mt-10 xl:text-4xl lg:text-3xl md:text-2xl text-xl text-center md:w-3/4'>{locale === 'en' ? data.titleEn : data.titleMn}</span>
        <p className='text-textMid mt-4 text-center 2xl:w-[680px] xl:w-[650px] lg:w-[600px] md:w-[560px] text-sm lg:text-base'>{locale === 'en' ? data.descriptionEn : data.descriptionMn}</p>
        <div className='lg:p-14 p-8 bg-surfaceInverse mt-16 rounded-xl 2xl:w-[997px] xl:w-[900px] lg:w-[803px] md:w-[706px] w-[95vw] aspect-[2/1] flex flex-col justify-center items-center gap-12'>
          {
            data.content?.map((item: SpecialOfferContent, i: number) => {
              return <NewsContentRenderer key={i} content={item} textColor={data.type === OfferType.Урамшуулал || data.type === OfferType.Бүртгэл ? 'text-textInverse' : 'text-textHigh'} />
            })
          }
          <Divider className='bg-secondaryMidStroke w-full' />
          <SocialShare
            url={getSystemEnv().DOMAIN + '/news/' + data.id.toString()}
            quote={locale === 'en' ? data.descriptionMn : data.descriptionEn}
            hashtag={locale === 'en' ? data.titleEn : data.titleMn}
          />
        </div>
      </div>
    </div>
  )
}
export default NewsContent
